import { NgModule, APP_INITIALIZER } from '@angular/core'
import { HttpModule, Http } from '@angular/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { AgmCoreModule } from '@agm/core'
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core'
import { TranslateFirebaseLoader } from './core/translate-firebase-loader'
import { AngularFireModule, FirebaseApp } from 'angularfire2'
import { AngularFireAuthModule } from 'angularfire2/auth'
import { AngularFireDatabaseModule } from 'angularfire2/database'
import { Angulartics2Module, Angulartics2GoogleAnalytics } from 'angulartics2'

import { AuthGuard } from './auth/auth-guard'

import { CoreModule } from './core/core.module'
import { ProfileModule } from './profile/profile.module'
import { UsersModule } from './users/users.module'
import { NotificationModule } from './notification/notification.module'
import { AuthModule } from './auth/auth.module'
import { SharedModule } from './shared/shared.module'
import { GeolocationModule } from './geolocation/geolocation.module'

import { AppComponent } from './app.component'
import { FirebaseService } from './core/core.module'

import { environment } from '../environments/environment'

export const firebaseConfig = {
  apiKey: 'AIzaSyAmrwIt0vR-xIWDlUXLP5ZgPofLfvRrpek',
  authDomain: 'cinomatch.firebaseapp.com',
  databaseURL: 'https://cinomatch.firebaseio.com',
  storageBucket: 'cinomatch.appspot.com',
  messagingSenderId: '832761709909'
}

export function FirebaseLoaderFactory(app: FirebaseApp, http: Http) {
  return new TranslateFirebaseLoader(app, http, `${environment.name}/`)
}

export function FirebaseServiceInitializer(firebaseService: FirebaseService): Function {
  return () => firebaseService.setRoot(environment.firebaseRoot)
}

export function TranslateServiceInitializer(translate: TranslateService): Function {
  return () => {
    translate.setDefaultLang('en')

    const lang = translate.getBrowserLang()
    return translate.use(lang).toPromise()
  }
}

// const firebaseAuthConfig = {
//     provider: AuthProviders.Facebook,
//     method: AuthMethods.Redirect
// }

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    HttpModule,
    RouterModule.forRoot([
      { path: 'login', loadChildren: 'app/login/login.module#LoginModule' },
      { path: 'tutorial', loadChildren: 'app/tutorial/tutorial.module#TutorialModule' },
      { path: 'chatroom', loadChildren: 'app/chatroom/chatroom.module#ChatroomModule' },
      {  path: '', loadChildren: 'app/home/home.module#HomeModule', canLoad: [AuthGuard] }
    ]),
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAJ6M65IjTnRuqd64CCnwcEQfjeVsky9Hk',
      libraries: ['places']
    }),
    CoreModule,
    UsersModule,
    NotificationModule,
    ProfileModule,
    GeolocationModule,
    SharedModule.forRoot(),
    AuthModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (FirebaseLoaderFactory),
        deps: [FirebaseApp, Http]
      }
    }),
    Angulartics2Module.forRoot([ Angulartics2GoogleAnalytics ])
    // ChatroomModule.forRoot()
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (FirebaseServiceInitializer),
      deps: [FirebaseService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (TranslateServiceInitializer),
      deps: [TranslateService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/app.module.ts